// extracted by mini-css-extract-plugin
module.exports = {"body":"ListNftModal_body__27Uk-","inputs":"ListNftModal_inputs__1I7cp","listButton":"ListNftModal_listButton__8BRU6","priceInput":"ListNftModal_priceInput__1llSH"};